import React from 'react';
import { StyleSheet, View } from 'react-native';
import {
  GroupLayout,
  JsonFormsRendererRegistryEntry,
  LayoutProps,
  rankWith,
  uiTypeIs,
} from '@jsonforms/core';
import { JsonFormsDispatch, withJsonFormsLayoutProps } from '@jsonforms/react';
import { RENDERER_RANK_DEFAULT_FALLBACK } from '../constants';

import { AppText } from '../../../AppText';

const styles = StyleSheet.create({
  groupLabel: {
    marginBottom: 30,
    fontWeight: 'bold',
  },
});

export const GroupRenderer: JsonFormsRendererRegistryEntry = {
  tester: rankWith(RENDERER_RANK_DEFAULT_FALLBACK, uiTypeIs('Group')),
  renderer: withJsonFormsLayoutProps((props: LayoutProps) => {
    const groupUiSchema = props.uischema as GroupLayout;
    return (
      <View>
        <AppText style={styles.groupLabel}>{props.label}</AppText>
        {groupUiSchema.elements && groupUiSchema.elements.length > 0 && (
          <View>
            {
              // render the child elements in the group
              groupUiSchema.elements.map((child, key) => (
                <View key={key}>
                  <JsonFormsDispatch {...props} uischema={child} />
                </View>
              ))
            }
          </View>
        )}
      </View>
    );
  }),
};
